module.exports = __webpack_public_path__ + "static/media/andywarhol.40c8cf73.jpg";